import { styled } from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow-y: hidden;
`;

export const ModalContent = styled.div`
  position: relative;
  background-color: white;
  padding: 20px 50px 20px 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

  display: flex;
  align-items: center;
  gap: 10px;

  /* Desktop width trimmed 60% -> 55% now that only one tab panel shows at a time.
     Farmer Info rows are percentage-based (label 30% / value 50%), so they reflow
     rather than cramp. Breakpoints below unchanged. */
  width: 55%;
  height: 50%;

  @media (max-width: 1250px) {
    width: 80%;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 0;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;

  width: 700px;
  height: 100%;
  overflow-y: auto;
  padding-right: 10px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #757575;
    border-radius: 20px;
    border: 3px solid transparent;
  }

  scrollbar-width: thin;
  scrollbar-color: #757575 transparent;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;

  @media (max-width: 800px) {
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
`;

export const SectionTitle = styled.div`
  background-color: #f0efec;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 10px 15px;
  font-size: 14px;
  color: #adaba8;

  text-transform: uppercase;
`;
export const SectionWrapper = styled.div`
  padding: 5px 10px;
`;
export const EarnedSection = styled.div`
  border: 1px solid #e8e6e2;
  border-radius: 10px;
`;
export const IncomeSection = styled.div`
  border: 1px solid #e8e6e2;
  border-radius: 10px;
`;
export const FarmerSection = styled.div`
  border: 1px solid #e8e6e2;
  border-radius: 10px;
`;
export const PlotsSection = styled.div`
  border: 1px solid #e8e6e2;
  border-radius: 10px;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  transition: transform 0.3s ease;

  img {
    width: 30px;
  }

  &:hover {
    transform: rotate(180deg);
  }

  @media (max-width: 800px) {
    display: none;
  }
`;

export const Icon = styled.img`
  width: 25px;
  height: 25px;
`;

export const FarmerInfoItem = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  border-bottom: 1px solid #e8e6e2;
  gap: 10px;

  &:last-child {
    border: none;
  }

  span {
    font-weight: bold;
    text-transform: uppercase;
    width: 30%;
  }

  p {
    margin: 0;
    width: 50%;
    margin-left: 10px;
    font-size: 14px;
    color: #333;
  }

  ul {
    margin: 0;
    margin-left: 20px;
    font-size: 14px;
  }
`;

export const PriceRow = styled.div`
  display: flex;
  justify-content: start;
  border-bottom: 1px solid #e8e6e2;
  margin-bottom: 30px;
  gap: 20px;
`;

export const PriceText = styled.p`
  margin: 0;
  font-size: 18px;
  color: #333;
  text-transform: uppercase;
`;

export const PriceBar = styled.p`
  margin: 0;
  font-size: 18px;
  color: #fff;
  text-transform: uppercase;
`;

export const BarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  margin: 20px 0;
  gap: 20px;
`;

export const Bar = styled.div<{ width: number; color: string }>`
  background-color: ${({ color }) => color};
  width: ${({ width }) => width}%;
  height: 30px;
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
  border-radius: 5px;
  color: white;
  font-size: 12px;
`;

export const LegendContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ColorBox = styled.div<{ color: string }>`
  width: 15px;
  height: 15px;
  background-color: ${({ color }) => color};
  border-radius: 3px;
`;

export const PlotRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #e8e6e2;
  text-transform: uppercase;

  &:last-child {
    border-bottom: none;
  }
`;

export const PlotName = styled.div`
  color: #e5007d;
  font-weight: bold;
  font-size: 14px;
`;

export const PlotDetail = styled.div`
  color: #333;
  font-size: 14px;
  width: 25%;

  strong {
    font-weight: bold;
    margin-right: 5px;
  }
`;

export const Tabs = styled.div`
  display: flex;
  justify-content: center;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 60px;
`;

export const Tab = styled.div<{ isActive: boolean; isLirp?: boolean }>`
  width: ${({ isLirp }) => (isLirp ? '25%' : '33%')};
  text-align: center;
  border-bottom: ${({ isActive }) => (isActive ? '1px solid #e5007d' : 'none')};
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  text-transform: uppercase;
  color: ${({ isActive }) => (isActive ? '#e5007d' : '#adaba8')};
  transition: all 0.3s ease;

  &:hover {
    color: #e5007d;
    border-bottom: 1px solid #e5007d;
  }

  @media (max-width: 800px) {
    font-size: 12px;
  }
`;

export const KgSoldHeader = styled.div`
  width: 25%;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
`;

export const EarnedHeader = styled.div`
  width: 25%;
  text-align: right;
  font-size: 14px;
  font-weight: bold;
`;

export const YearHeader = styled.div`
  width: 20%;
`;

export const Row = styled.div`
  display: flex;
  justify-content: start;
  gap: 10px;
  font-size: 16px;
  padding: 5px 0;
  border-bottom: 1px solid #e8e6e2;
`;

export const RowTotal = styled(Row)`
  font-weight: bold;
`;

export const SubRow = styled.div`
  display: flex;
  justify-content: start;
  gap: 10px;
  font-size: 14px;
  padding: 5px 0;
`;

export const Year = styled.div`
  width: 20%;
  font-weight: bold;
  color: #333;
  text-transform: uppercase;
`;

export const KgSold = styled.div`
  width: 25%;
  text-align: left;
  color: #333;
`;

export const Earned = styled.div`
  width: 25%;
  text-align: right;
  color: #333;
`;

export const Label = styled.div`
  width: 20%;
`;

export const Price = styled.div`
  width: 25%;
  text-align: right;
  color: #333;
`;

export const EmptyTag = styled.div`
  width: 25%;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  border-top: 1px solid #e8e6e2;
`;

export const TotalText = styled.div`
  font-weight: bold;
  color: #e5007d;
  text-transform: uppercase;
`;

export const TotalAmount = styled.div`
  color: #e5007d;
  font-weight: bold;
`;

export const DetailsLink = styled.a`
  color: #888;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: #333;
  }
`;

export const PricePerKilo = styled.p`
  font-size: 14px;
  color: #333;
  text-transform: uppercase;
  margin-top: 10px;
`;

// Livefeed sentence shown in place of the Moyee price (which is 0/null on the
// public layer) - points users to live pricing at livefeed.moyeecoffee.com.
// Plain lead-in text with only the platform name as an inline hyperlink.
export const LivefeedText = styled.p`
  margin-top: 12px;
  font-size: 14px;
  color: #333;
  line-height: 1.4;
`;

export const LivefeedLink = styled.a`
  color: #e5007d;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #b3005f;
  }
`;
